<template>
  <div class="animated">
    <v-client-table
      :columns="show_columns"
      :data="managedSubList"
      :options="options"
      :theme="theme"
      id="managed-sub-lists-table"
      class="w-100"
    >
      <span slot="list" slot-scope="{ row }">
        <a :href="'#/managed-lists/' + row.id" class="btn-link">
          {{ row.description }}
        </a>
      </span>
      <span slot="parent_list" slot-scope="{ row }">
        {{ row.parent.description }}
      </span>
      <span slot="attributes" slot-scope="{ row }">
        {{ row.attribute_lists.length }}
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "ManagedListsTable",
  components: { ClientTable },
  props: {
    managedSubList: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => ["list", "parent_list", "attributes"]
    }
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.managedSubList,
      options: {
        headers: {
          list: "List",
          parent_list: "Parent List",
          attributes: "Attributes"
        },
        filterable: false
      },
      theme: "bootstrap4",
      template: "default"
    };
  }
};
</script>
